import { useQuery } from '@tanstack/react-query';
import { optInFeaturesQueryKeys } from '../Constants/queryKeys';
import { getOptInFeatureById } from '../Services/OptInFeatures.service';

/** One feature, with every language. Idle until there is an id — the form also serves `/new`. */
export const useOptInFeature = (id?: string) =>
  useQuery({
    queryKey: optInFeaturesQueryKeys.detail(id ?? ''),
    queryFn: () => getOptInFeatureById(id ?? ''),
    enabled: Boolean(id),
  });
